import _slicedToArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Loader } from '../Loader';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickDataProps, pickAriaProps, pickComponentCommonProps } from '../../interfaces/commonProps';
import { useTransitionEvent } from '../../hooks/useTransitionEvent';
import { StyledButton, StyledArrow, StyledIconContainer, StyledButtonLabel, StyledTransitionContainer } from './Button.styles';
/**
 * Buttons can be used to show the user’s choice of options for actions and assign these to a clear hierarchy.
 */

export var Button = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? undefined : _ref$href,
      icon = _ref.icon,
      name = _ref.name,
      _ref$newWindow = _ref.newWindow,
      newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$stretch = _ref.stretch,
      stretch = _ref$stretch === void 0 ? false : _ref$stretch,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      variant = _ref.variant,
      value = _ref.value,
      restProps = _objectWithoutProperties(_ref, ["children", "loading", "disabled", "href", "icon", "name", "newWindow", "onClick", "size", "stretch", "type", "variant", "value"]);

  // Rebuild props to pass down, handling any conditionals...
  var props = _objectSpread({
    onClick: onClick,
    size: size,
    stretch: stretch,
    variant: variant,
    isLoading: loading,
    disabled: disabled,
    outerSpacing: useSpacing(restProps)
  }, pickComponentCommonProps(restProps), {}, pickDataProps(restProps), {}, pickAriaProps(restProps), {}, !disabled && {
    href: href
  }, {}, href ? _objectSpread({
    as: 'a'
  }, newWindow && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }) : {
    disabled: disabled,
    name: name,
    type: type,
    value: value
  });

  props.isLoading = props.variant !== 'text' && props.isLoading;
  props.disabled = props.isLoading || props.disabled;

  var _React$useState = React.useState(props.isLoading),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loaderVisible = _React$useState2[0],
      setLoaderVisible = _React$useState2[1];

  var handleTransitionEvent = React.useCallback(function (e) {
    if (e.currentTarget) {
      var opacity = getComputedStyle(e.currentTarget).opacity;
      setLoaderVisible(opacity !== '0');
    }
  }, [setLoaderVisible]);
  var transitionElementRef = useTransitionEvent(handleTransitionEvent);
  return React.createElement(StyledButton, _objectSpread({
    ref: ref
  }, props), React.createElement(StyledTransitionContainer, {
    overlay: true,
    visible: props.isLoading,
    ref: transitionElementRef,
    "aria-hidden": true
  }, loaderVisible && React.createElement(Loader, {
    monochrome: true,
    size: "small",
    inverted: variant === 'primary'
  })), React.createElement(StyledTransitionContainer, {
    overlay: false,
    visible: !props.isLoading
  }, icon && React.createElement(StyledIconContainer, null, icon), React.createElement(StyledButtonLabel, {
    size: size,
    icon: !!icon
  }, children), !icon && variant === 'text' && React.createElement(StyledArrow, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "13",
    viewBox: "0 0 8 13"
  }, React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1px",
    fill: "none",
    d: "M1.5,1l5.485,5.504l-5.48,5.496"
  }))));
});
Button.displayName = 'Button';